import cardService from '../../service/carsResource';

const initalState = {
  cards: [],
  addedColecctionCard: [],
  allCardsByTransportation: [],
  cardsLoading: false,
  cardsPage: 0,
  cardsSortModel: [],
  cardsPageCount: 0,
};
export const createCardStore = (set, get) => ({
  ...initalState,
  setCardsPage: (e) => set({ cardsPage: e }),
  setCardsSortModel: (sortModel) => set({ cardsSortModel: sortModel }),
  fetchCards: async (data) => {
    set({ error: '' });
    const sortModel = get().sortModel;
    const { field, sort } =
      sortModel.length > 0
        ? get().cardsSortModel[0]
        : { field: 'id', sort: 'desc' };
    const { transportationId, isMobile } = data;
    try {
      set({ cardsLoading: true });
      const params = {
        transportationId: transportationId,
        size: isMobile ? 5 : 10,
        page: get().cardsPage,
        sort: `${field},${sort}`,
      };
      const result = await cardService.getCardEventsByTransportationId(params);
      const resultAll = await cardService.getAllCardEventsByTransportationId({
        transportationId,
      });
      const dataAll = resultAll?.data?.data;
      const data = result?.data?.data;
      const properties = result?.data?.properties;
      set({
        cardsPageCount:
          properties?.totalPages === null || 0 ? 1 : properties.totalPages,
      });
      if (data === null || data.length === 0) {
        set({ error: 'Kart Bilgisi Bulunamadı' });
      }
      set({ cards: data === null ? [] : data });
      set({ allCardsByTransportation: dataAll === null ? [] : dataAll });
    } catch (error) {
      console.log(error);
    } finally {
      set({ cardsLoading: false });
    }
  },
  fetchAllCardsByTransportation: async (transportationId) => {
    try {
      const result = await cardService.getAllCardEventsByTransportationId({
        transportationId,
      });
      const data = result?.data?.data;
      set({ allCardsByTransportation: data === null ? [] : data });
    } catch (error) {
      console.log(error);
    }
  },
});
